module.exports = __webpack_public_path__ + "img/zebrawood-mask.edd889b8.png";